/** AATOZZ bespoke landing constants. */

/** Used until the admin sets social links in the Storefront tab. */
export const FALLBACK_SOCIAL = [
  { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61581685650362' },
];

/** The handoff's price format: "₱2,500", centavos only when there are any. */
export const peso = (n: number) => `₱${n.toLocaleString('en-PH', { maximumFractionDigits: 2 })}`;

/** A whole peso amount without the sign, for the kit cards' big serif figure. */
export const pesoDigits = (n: number) => n.toLocaleString('en-PH', { maximumFractionDigits: 2 });

/**
 * A kit's ticked list: the lines of its product description, bullets and
 * dashes stripped, at most five. One line of prose is one item.
 */
export function descriptionLines(text: string | null | undefined): string[] {
  return (text ?? '')
    .split('\n')
    .map((l) => l.replace(/^\s*[-•*]\s*/, '').trim())
    .filter(Boolean)
    .slice(0, 5);
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase() || '•';
}
